import React from 'react';

import type { ToolbarContextType } from './../../../../ricos-context';
import { withToolbarContext } from './../../../../ricos-context';
import type { IToolbarItem } from './../../../../ricos-types/toolbarTypes';

import CustomHeadingButton from '../CustomHeadingButton/CustomHeadingButton';
import HeadingButton from '../HeadingButton/HeadingButton';

const HeadingButtonSwitch = ({
  toolbarItem,
  context,
  dataHook,
}: {
  toolbarItem: IToolbarItem;
  context: ToolbarContextType;
  dataHook?: string;
}) => {
  const { headingsData } = context || {};
  if (!context) return null;

  return headingsData?.allowHeadingCustomization ? (
    <CustomHeadingButton toolbarItem={toolbarItem} dataHook={dataHook} />
  ) : (
    <HeadingButton toolbarItem={toolbarItem} dataHook={dataHook} />
  );
};

export default withToolbarContext(HeadingButtonSwitch);
